export const formatError = (error: any) => {
  if (error.errors) {
    return `${error.message}\n${
      error.errors && error.errors.map((e) => e.path.replace('instance.', '') + ': ' + e.value).join('\n')
    }`;
  }
  return error.message;
};
